/**
 * Created by fers on 05.02.16.
 */

import Grid from './Grid.react';
import {FormattedMessage} from 'react-intl';

import React from 'react';
import PropTypes from 'prop-types';
import {getQueryParams} from '../../common/util/QueryParams';
import LoadingButton from '../fw/LoadingButton.react';

export const defaultPageSize = 200;

export function processPagingParams(variables) {
    if (!variables) {
        return;
    }

    let queryArgs = "";
    if (typeof window === 'object' && 'location' in window) {
        queryArgs = window.location.search || '';
    }

    let queryParams = getQueryParams(queryArgs || '');
    if (!variables.after && queryParams.after) {
        variables.after = queryParams.after;
    }
    if (!variables.before && queryParams.before) {
        variables.before = queryParams.before;
    }

    return variables;
}

export default class PagingGrid extends React.Component {
    static propTypes = {
        edges: PropTypes.object.isRequired,
        pageInfo: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        renderLink: PropTypes.bool,
    };

    static defaultProps = {
        renderLink: true
    };

    constructor(props) {
        super(props);

        this.state = {
            pageSize: props.pageInfo && props.pageInfo.hasNextPage ? parseInt(atob(props.pageInfo.endCursor).split(':')[1], 10) + 1 : defaultPageSize,
            hasNextPage: props.pageInfo ? props.pageInfo.hasNextPage : false,
            hasPreviousPage: false,
            pagination: 0,
            maxPage: props.pageInfo.hasNextPage ? 1 : 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            hasNextPage:  this.state.pagination < this.state.maxPage ? true : nextProps ? nextProps.pageInfo.hasNextPage : false,
            hasPreviousPage: nextProps && nextProps.pageInfo && nextProps.pageInfo.startCursor ? parseInt(atob(nextProps.pageInfo.startCursor).split(':')[1], 10) > 0 : false
        });
    }

    nextPage = () => {
        return new Promise((resolve, reject) => {
            //let currentUrl = window.location.pathname;
            //window.history.pushState("", "", currentUrl + '?after=' + encodeURIComponent(this.props.pageInfo.endCursor));

            this.setState({
                pagination: this.state.pagination + 1,
                maxPage: this.state.maxPage < this.state.pagination + 1 ? this.state.pagination + 1 : this.state.maxPage,
            });

            const cursor = this.props.pageInfo.endCursor;
            this.props.relay.setVariables({ after: cursor, before: null, first: this.state.pageSize, last: null }, (state) => {
                if (state.done) {
                    resolve();
                } else if (state.error) {
                    reject();
                }
            });
        });
    };

    previousPage = () => {
        return new Promise((resolve, reject) => {
            //let currentUrl = window.location.pathname;
            //window.history.pushState("", "", currentUrl + '?before=' + encodeURIComponent(this.props.pageInfo.startCursor));

            this.setState({
                pagination: this.state.pagination - 1,
            });

            this.props.relay.setVariables({ after: null, before: this.props.pageInfo.startCursor, first: null, last: this.state.pageSize }, (state) => {
                    if (state.done) {
                        resolve();
                    } else if (state.error) {
                        reject();
                    }
            });
        });
    };

    render() {
        let list = this.props.edges.edges.map(({node}) => node);

        let currentUrl = "";
        if (typeof window === 'object' && 'location' in window) {
            currentUrl = window.location.pathname;
        }

        return (
            <div>
                <Grid {...this.props} list={list}/>

                <div aria-label="..." className="btn-group" role="group">
                    {this.state.hasPreviousPage ? <LoadingButton className="btn btn-default" href={currentUrl + "?before=" + encodeURIComponent(this.props.pageInfo.startCursor)} onClick={this.previousPage}><FormattedMessage defaultMessage="Load previous…" id="msg.loadPrevious" /></LoadingButton> : null}
                    {this.state.hasNextPage ? <LoadingButton className="btn btn-default" href={currentUrl + "?after=" + encodeURIComponent(this.props.pageInfo.endCursor)} onClick={this.nextPage}><FormattedMessage defaultMessage="Load more…" id="msg.loadMore" /></LoadingButton> : null}
                </div>
            </div>
        );
    }
}
